<template lang="pug">
  .operator-requests
    .admin-page__title
      h1.title Все заявки
    .admin-page__filters
      .select-filter
        .form
          .form__elem
            custom-select(
            :list-data="events"
            :show-list="true"
            :read-only="false"
            :type="'event'"
            :default-value="filter.event"
            @on-change-default-value="changeSelectValue"
            )
          .form__elem
            custom-select(
            :list-data="areas"
            :show-list="true"
            :read-only="false"
            :type="'area'"
            :default-value="filter.area"
            @on-change-default-value="changeSelectValue"
            )
          .form__elem
            custom-select(
            :list-data="awards"
            :show-list="true"
            :read-only="false"
            :type="'award'"
            :default-value="filter.award"
            @on-change-default-value="changeSelectValue"
            )
          .form__elem
            input.input(
            placeholder="Поиск по ФИО"
            @input="onFilterNameChange"
            v-model="filter.name"
            )
    .admin-page__status-filters
      status-filter(
      :status="orders_status_total"
      @change="setFilter"
      :show-canceled-status="false"
      )
    .admin-page__actions
      table-actions(
      :count="selected.length"
      @onButtonClick="onActionButtonClick"
      )
    .admin-page__table
      requests-table(
      :orders="orders"
      @change="selectItem"
      )
    .admin-page__pagination(
    v-if="paginationAmountToShow < ordersAmount"
    )
      custom-pagination(
      :elements-amount="ordersAmount"
      :amount-to-show="paginationAmountToShow"
      :current-page="paginationCurrentPage"
      @on-button-click="onPaginationButtonClick"
      )
</template>

<script>
import { mapActions } from "vuex";
import RequestsTable from "../../../../components/requests-table/requests-table";
import CustomSelect from "../../../../components/custom-select/custom-select";
import StatusFilter from "../../../../components/status-filter/status-filter";
import TableActions from "../../../../components/table-actions/table-actions";
import Modal from "../../../../components/modal/modal";
import CustomPagination from "../../../../components/pagination/pagination";

export default {
  name: "admin-all-requests",
  components: {
    CustomPagination,
    Modal,
    TableActions,
    StatusFilter,
    CustomSelect,
    RequestsTable,
  },
  data() {
    return {
      awards: [],
      areas: [],
      events: [],
      orders: [],
      params: {
        current_status__in: "1,2,3,4,5,6,8",
      },
      selected: [],
      orders_status_total: [],
      filter: {
        event: {
          value: null,
          text: "Мероприятия",
          paramName: "title",
        },
        area: {
          value: null,
          text: "Районы",
          paramName: "name",
        },
        award: {
          value: null,
          text: "Конкурсы",
          paramName: "title",
        },
        name: "",
      },
      timerId: null,

      /*для пагинации*/
      ordersAmount: null,
      paginationAmountToShow: 25,
    };
  },
  computed: {
    paginationCurrentPage() {
      return Number(this.$route.query.page) || 1;
    },
  },
  methods: {
    ...mapActions([
      "getOrders",
      "getAwardTypes",
      "getAreas",
      "getEvents",
      "updateOrderStatus",
    ]),
    onGetOrders(pageNumber) {
      this.params.page_size = this.paginationAmountToShow;
      this.params.page = pageNumber;
      this.getOrders(this.params).then((res) => {
        this.orders = res.results;
        this.orders_status_total = res.orders_status_total;
        this.ordersAmount = res.count;
      });
    },
    changeSelectValue(data, type) {
      this.filter[type] = data;
      this.params.event = this.filter.event.value;
      this.params.area__in = this.filter.area.value;
      this.params.order_have_award_type__in = this.filter.award.value;
      this.onPaginationButtonClick(1);
    },
    setFilter(status) {
      if (status) {
        this.params.current_status__in = status;
      } else {
        this.params.current_status__in = "1,2,3,4,5,6,8";
      }
      this.selected = [];
      this.onPaginationButtonClick(1);
    },
    onPaginationButtonClick(button) {
      if (Number(this.$route.query.page) !== button) {
        this.$router.replace({ query: { page: button } });
      }
      this.onGetOrders(button);
    },

    selectItem(selected) {
      this.selected = selected;
    },
    onGetEvents() {
      this.getEvents().then((res) => {
        this.events.push(this.filter.event);
        let eventX = res.map((event) => ({
          text: event.title,
          value: event.id,
        }));
        this.events.push(...eventX);
      });
    },
    onGetAreas() {
      this.getAreas().then((res) => {
        this.areas.push(this.filter.area);
        let areaX = res.map((area) => ({
          text: area.name,
          value: area.id,
        }));
        this.areas.push(...areaX);
      });
    },
    onGetAward() {
      this.getAwardTypes().then((res) => {
        this.awards.push(this.filter.award);
        let awardX = res.map((award) => ({
          text: award.title,
          value: award.id,
        }));
        this.awards.push(...awardX);
      });
    },
    onActionButtonClick() {
      console.log("Клик по кнопке действий");
      /*if (this.selected.length > 0) {
        this.selected.forEach(i => {
          this.updateOrderStatus({ id: i, status: status }).then(res => {
            if (res.status === 400) {
              this.showModal = true;
              this.modalData.number = i;
              this.modalData.text = res.data.status[0].message;
            }
          });
        });
        this.setFilter(status);
        this.selected = [];
      }*/
    },

    onFilterNameChange() {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        if (this.filter.name.length > 0) {
          this.params.user_full_name = this.filter.name;
        } else {
          this.params.user_full_name = null;
        }
        this.onPaginationButtonClick(1);
      }, 400);
    },
  },
  mounted() {
    this.onGetAward();
    this.onGetEvents();
    this.onGetAreas();
    this.onGetOrders(this.paginationCurrentPage);
  },
};
</script>
